module.exports = __webpack_public_path__ + "static/img/2_2_2.ba1ef88b.jpg";